/**
 * Values shown on the Privacy Policy, Terms of Service and Credits pages.
 * Keep these accurate — Google's OAuth verification reviewers read these pages.
 */
export const LEGAL = {
  appName: 'FitTrack',
  siteUrl: 'https://fittrack.site',
  // Must be a monitored inbox: users send privacy and account-deletion requests here.
  contactEmail: 'support@fittrack.site',
  effectiveDate: 'September 17, 2026',
};
